export default __webpack_public_path__ + "static/media/bar_vertical.0d09f623.png";